import React, { useRef, useEffect, useCallback, useState} from 'react';
import {
    setParameterToMap,
    setContextualHelp} from 'actions/index.js';
import {BPM_SLIDER} from 'constants/contextual-help.js';
import {sleep} from 'utils/sleep.js';
import {connect} from 'react-redux';

const DOUBLE_CLICK_TIME = 250;

const BPMComponent = ({
    setParameterToMap,
    bpm, sequencerEngine,
    setContextualHelp, isMacroMapping}) => { 
    let [yPosition, setYPosition] = useState(0);
    let [editing, setEditing] = useState(false);
    let [bpmValue, setBpmValue] = useState(bpm);
    let changing = useRef(false);
    let dist = useRef(0);
    let lastClick = useRef(0);

    useEffect(() => {
        window.addEventListener("mousedown", clearEditing);
        return () => window.removeEventListener("mousedown", clearEditing);
    }, [editing, setEditing]);

    const clearEditing = useCallback(() => {
        if (editing) {
            setEditing(false);
        }
    }, [editing, setEditing]);

    const onMouseDown = useCallback(async (e) => {
        if (isMacroMapping) {
            if (!sequencerEngine.bpmParameter.isMapped) {
                setParameterToMap(sequencerEngine.bpmParameter);
            }
        }
        e.stopPropagation();
        let date = new Date().getTime();
        if (date - lastClick.current <= DOUBLE_CLICK_TIME) {
            setEditing(true);
            return;
        }
        lastClick.current = date;

        let y = e.clientY;
        setYPosition(y);
        dist.current = 0;
        changing.current = true;

        while (changing.current) {
            let d = dist.current;
            sequencerEngine.bpm = Math.round(sequencerEngine.bpmParameter.get() - d / 5.0);
            await sleep(50);
        }

    }, [setYPosition, setEditing, isMacroMapping]);

    const onMouseUp = useCallback((e) => {
        changing.current = false;
        setContextualHelp(undefined);
    }, []);

    const onMouseMove = useCallback((e) => {
        if (changing.current) {
            dist.current = e.clientY - yPosition;
        }
    }, [yPosition]);

    let rounded = Math.round(bpm*10) / 10;

    const onChange = useCallback((e) => {
        let text = e.target.value;
        setBpmValue(text);
        if (parseFloat(text)) {
            sequencerEngine.bpm = parseFloat(text);
        }
    }, [sequencerEngine, setBpmValue]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            setEditing(false);
        }
    }, [setEditing]);

    return (
        <div
          onMouseOver={() => setContextualHelp(BPM_SLIDER)}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
          onMouseMove={onMouseMove}
          className="bpm-component">
          {editing ?
           <input
             onKeyDown={onKeyDown}
             onChange={onChange}
             value={bpmValue}
             type="text"
             className="bpm-input"/> :
         rounded}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      bpm: props.sequencerEngine.bpmParameter.get(),
      isMacroMapping: state.effects.isMacroMapping,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setContextualHelp: (x) => dispatch(setContextualHelp(x)),
      setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BPMComponent);
